/*ReactJS*/
import React from 'react';
import Table from '../../../../components/ClearingTable/Table';

export default function ActivityOtherFeesTable(props) {
  return <Table {...props} />;
}
